import { useDispatch, useSelector } from 'react-redux';
import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import { editOverviewTask } from '@/store/slices/components/dashboard/service';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';
import { COMPLETED_TASK_STATUS } from '@/components/Tasks/constants/status';
import styles from './overviewTasks.module.scss';
import { showToast } from '@/store/slices/components/toast/ToastSlice';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import { setTasks } from '@/store/slices/components/tasks/TasksSlice';
import MixPanelService from '@/services/MixPanelService';

export default function OverviewTasksRow({ task, isOverdue = false }) {
  const dispatch = useDispatch();
  const tasksRefreshCount = useSelector(
    (state) => state.TasksSlice.refreshCount
  );
  const {
    id,
    completing,
    title,
    time_display,
    property_address,
    contact_name,
    property,
    contacts,
  } = task;
  const arbitraryContact = contacts?.[0] ?? null;
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const hasProperty = Boolean(property_address || property?.name);
  const hasContact = Boolean(contact_name || arbitraryContact?.name);

  const handleClickTask = async (taskId) => {
    const payload = { status: COMPLETED_TASK_STATUS };

    try {
      await dispatch(editOverviewTask({ id: taskId, payload })).unwrap();
      dispatch(showToast({ text: Trans(translations, 'YouCompletedATask') }));
      dispatch(setTasks({ key: 'refreshCount', value: tasksRefreshCount + 1 })); // to update rightbar
      MixPanelService.track({
        event_name: 'platform_tasks_complete',
        extra_info: {
          overdue: isOverdue,
          'completion-module': 'dashboard',
        },
      });
    } catch (error) {
      console.log(error);
      dispatch(
        showToast({ text: Trans(translations, 'DefaultError'), type: 'danger' })
      );
    }
  };

  const handleClickProperty = () => {
    if (!property?.id) return;
    dispatch(showQuickDisplay({ id: property.id }));
  };

  return (
    <Box className={`${styles.row} ${completing ? styles.rowCompleted : ''}`}>
      <Box className={styles.checkbox} onClick={() => handleClickTask(id)}>
        {completing && (
          <Icon icon="icon-aceptar" className={styles.checkIcon} />
        )}
      </Box>
      <Box className={styles.content}>
        <Box className={styles.header}>
          <Text className={styles.title}>{title}</Text>
          {time_display && (
            <Box className={isOverdue ? styles.timeOverdue : styles.time}>
              {isOverdue && <Icon icon="icon-reloj" />}
              <Text>{time_display}</Text>
            </Box>
          )}
        </Box>
        {(hasProperty || hasContact) && (
          <Box className={styles.metaRow}>
            {hasProperty && (
              <Box className={styles.meta}>
                <Icon icon="icon-propiedades" className={styles.metaIcon} />
                {property?.id ? (
                  <Text
                    className={styles.propertyText}
                    onClick={handleClickProperty}
                  >
                    {property?.name ?? property_address}
                  </Text>
                ) : (
                  <Text className={styles.metaText}>
                    {property_address ?? property?.name}
                  </Text>
                )}
              </Box>
            )}

            {hasProperty && hasContact && (
              <Box className={styles.metaSeparator} />
            )}

            {hasContact && (
              <Box className={styles.meta}>
                <Icon icon="icon-contactos" className={styles.metaIcon} />
                {arbitraryContact?.id ? (
                  <Box
                    as="a"
                    href={`${tokkoBrokerHost}/contact/${arbitraryContact.id}/`}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.contactText}
                  >
                    {arbitraryContact.name}
                  </Box>
                ) : (
                  <Text className={styles.metaText}>
                    {contact_name ?? arbitraryContact?.name}
                  </Text>
                )}
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}
